module.exports = __webpack_public_path__ + "img/icon_shopping.f1ae1cc9.png";